import axios from "axios";
import router from "../router";
import { message } from "ant-design-vue";

//const SERVER_ROOT_URL = "http://localhost:8088/gpws/";
const SERVER_ROOT_URL = process.env.VUE_APP_ApiUrl;
axios.defaults.baseURL = SERVER_ROOT_URL;
axios.defaults.timeout = 300000;
axios.defaults.withCredentials = true;

axios.defaults.headers = {
  post: {
    "Content-Type": "application/json;charset=utf-8",
    version: "1.0",
  },
  get: {
    "Content-Type": "application/json;charset=utf-8",
    version: "1.0",
  },
};

//请求拦截器
axios.interceptors.request.use(
  function(config) {
    if (config.method === "post" && null != config.data) {
      if (config.headers["Content-Type"]) {
        if (
          config.headers["Content-Type"].toLowerCase() ===
            "application/json;charset=utf-8" ||
          config.headers["Content-Type"].toLowerCase() === "application/json"
        ) {
          config.data = JSON.stringify(config.data);
        }
      } else {
        config.data = JSON.stringify(config.data);
      }
    }
    if (localStorage.token) {
      try {
        let token = JSON.parse(localStorage.token);
        config.headers["Authorization"] = "Bearer " + token.access_token;
      }catch (e) {
        console.info(e)
      }

    }

    if (localStorage.getItem("curruser")) {
      let member = JSON.parse(localStorage.getItem("curruser"));

      if (member.expire > new Date().getTime()) {
        let date = new Date();
        date.setMinutes(date.getMinutes() + 30);
        member.expire = date.getTime();

        localStorage.setItem("curruser", JSON.stringify(member));
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("curruser");
        router.replace({ path: "/" });
      }
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

//响应拦截器
axios.interceptors.response.use(
  function(response) {
    if (response.headers.authorization) {
      localStorage.setItem("token", response.headers.authorization);
    }
    return response.data;
  },
  function(error) {
    if (undefined != error.response && null != error.response && error.response.status == 401) {
      localStorage.removeItem("token");
      if (router.currentRoute.meta.requireAuth) {
        router.replace({
          path: "/login",
          query: { redirect: router.currentRoute.fullPath },
        });
      }
    }
    if (undefined != error.response && null != error.response && null !== error.response.data) {
      message.error(error.response.data.msg.message);
      return Promise.reject(error.response.data.msg.message);
    } else {
      if(undefined != error.message && null != error.message){
        if (error.message.indexOf("timeout") >= 0) {
          message.error("传输故障，请稍后再试");
          return Promise.reject("请求超时");
        } else if (error.message.indexOf("Network Error") >= 0) {
          message.error("网络连接错误");
          return Promise.reject("网络连接错误");
        } else if (error.message.indexOf("404") >= 0) {
          message.error("未找到相应接口");
          console.log("未找到相应接口");
        }
      }else{
        message.error("后台返回空.");
      }
    }
  }
);
